import { httpRequest } from '@/services/httpRequest';

/**
 * Download the original source document (.docx) stored for a policy and
 * save it via the browser's download flow.
 */
export const downloadPolicySourceDocument = async (
  policyId: number,
  filename: string,
): Promise<void> => {
  const { data } = await httpRequest({
    url: `/v1/protected/policies/${policyId}/source-document`,
    method: 'GET',
    responseType: 'blob',
  });

  const url = URL.createObjectURL(data as Blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};

/**
 * Read a File as base64 (without the data: URL prefix), suitable for the
 * policy create/update `source_document` field.
 */
export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      resolve(result.split(',')[1] ?? '');
    };
    reader.onerror = () => reject(reader.error ?? new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
